/**
 * Heap Leach Slots leaderboard — the global top 10, served by Maestro.
 *
 * Entries are anonymous: the board stores only the alias the player types, so
 * a score is never attributable to a user or company. Personal bests are a
 * separate, device-local concern — see slotMachineRecords.js.
 */
import apiService from './apiService';

/**
 * @returns {Promise<{leaderboard: Array, size: number, isFull: boolean, cutoff: number|null}>}
 *   cutoff is the score a new entry must beat, or null while slots remain.
 */
export async function fetchLeaderboard(token) {
  return apiService.get('/v1/slots/leaderboard', token);
}

/**
 * Submit a score under a player-chosen alias. A score that doesn't clear the
 * cutoff comes back as `qualified: false` — that is a normal outcome, not an
 * error, and nothing is stored.
 */
export async function submitScore({ alias, score, spins }, token) {
  return apiService.post('/v1/slots/score', { alias, score, spins }, token);
}

/** True when `score` would make the board as currently loaded. */
export function qualifiesForBoard(score, board) {
  if (!board) return false;
  if (!board.isFull) return true;
  return typeof board.cutoff === 'number' && score > board.cutoff;
}
